export default __webpack_public_path__ + "static/media/low fat.bf6f3660.jpeg";